import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogsDashboard from "./features/logs/LogsDashboard.vue";


export default {
  __name: 'AdminDashboard',
  props: {
	adminApiUrl: {
		type: String,
		required: true,
	},
	userApiUrl: {
		type: String,
		required: true,
	},
},
  setup(__props) {

const props = __props;

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(LogsDashboard, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */))
}
}

}